import React, { useContext, useState } from "react";
import Layout from "../components/Layout";
import BackgroundImage from "gatsby-background-image";
import { graphql } from "gatsby";
import "../components/main.scss";
import { Link } from "gatsby";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { CartContext } from "../context/CartContext";
import ButtonCart from "../components/ButtonCart";
import Nav from "../components/Nav";
import { Helmet } from "react-helmet";
import { motion, useViewportScroll } from "framer-motion";
import { useInView, InView } from "react-intersection-observer";
import ScrollButton from "../components/ScrollButton";

const IndexPage = (props) => {
  const { products } = useContext(CartContext);

  const img = getImage(
    props.data.Owners.edges[0].node.frontmatter.featuredImage.childImageSharp
  );
  const imgAbout = getImage(props.data.AboutImg.childImageSharp);

  function Variants(x, duration) {
    const Variants = {
      offscreen: { opacity: 0, x: x },
      onscreen: {
        opacity: 1,
        x: 0,
        transition: {
          duration: duration,
        },
      },
    };
    return Variants;
  }

  const left = Variants(-100, 2);
  console.log(left);
  const yVariants = {
    offscreen: { opacity: 0, y: 100 },

    onscreen: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1.5,
      },
    },
  };
  const leftVariants = {
    offscreen: { opacity: 0, x: -100 },

    onscreen: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
      },
    },
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
        <title>Home page</title>
        <link rel="icon" type="image/x-icon" href="../images/favicon.ico" />
      </Helmet>
      <Layout>
        <Nav home="nav-active" />
        <header class="homepage-header">
          <BackgroundImage
            fluid={props.data.file.childImageSharp.fluid}
            class="header-bg"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="black-overlay">
              <div class="container1" style={{ width: "100%", height: "100%" }}>
                <div className="homepage-header-text">
                  <motion.div
                    variants={Variants(-100, 1)}
                    initial="offscreen"
                    whileInView="onscreen"
                  >
                    <p>FRESH & ORGANIC</p>
                    <h1>Delicious Seasonal Fruits</h1>
                  </motion.div>
                  <motion.div
                    variants={yVariants}
                    initial="offscreen"
                    whileInView="onscreen"
                  >
                    <ul>
                      <li>
                        <Link to="#products">Our products</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </motion.div>
                </div>
              </div>
            </div>
          </BackgroundImage>
        </header>
        <div style={{ position: "relative" }}>
          <section className="homepage-list-section">
            <div className="container1">
              <ul>
                <li>
                  <div className="svg">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="truck-fast"
                      class="svg-inline--fa fa-truck-fast"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                    >
                      <path
                        fill="currentColor"
                        d="M64 48C64 21.49 85.49 0 112 0H368C394.5 0 416 21.49 416 48V256H608V352C625.7 352 640 366.3 640 384C640 401.7 625.7 416 608 416H576C576 469 533 512 480 512C426.1 512 384 469 384 416H256C256 469 213 512 160 512C106.1 512 64 469 64 416V288H208C216.8 288 224 280.8 224 272C224 263.2 216.8 256 208 256H16C7.164 256 0 248.8 0 240C0 231.2 7.164 224 16 224H240C248.8 224 256 216.8 256 208C256 199.2 248.8 192 240 192H48C39.16 192 32 184.8 32 176C32 167.2 39.16 160 48 160H272C280.8 160 288 152.8 288 144C288 135.2 280.8 128 272 128H16C7.164 128 0 120.8 0 112C0 103.2 7.164 96 16 96H64V48zM160 464C186.5 464 208 442.5 208 416C208 389.5 186.5 368 160 368C133.5 368 112 389.5 112 416C112 442.5 133.5 464 160 464zM480 368C453.5 368 432 389.5 432 416C432 442.5 453.5 464 480 464C506.5 464 528 442.5 528 416C528 389.5 506.5 368 480 368zM466.7 160H400V96H466.7C483.7 96 499.1 102.7 512 114.7L589.3 192C601.3 204 608 220.3 608 237.3V288H544V237.3L466.7 160z"
                      ></path>
                    </svg>
                  </div>
                  <div className="homepage-list-section-content">
                    <h3>Free Shipping</h3>
                    <p>When order over $75</p>
                  </div>
                </li>
                <li>
                  <div className="svg">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="phone-volume"
                      class="svg-inline--fa fa-phone-volume"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M284.6 181.9c-10.28-8.344-25.41-6.875-33.75 3.406C242.4 195.6 243.9 210.7 254.2 219.1c11.31 9.25 17.81 22.69 17.81 36.87c0 14.19-6.5 27.62-17.81 36.87c-10.28 8.406-11.78 23.53-3.375 33.78c4.719 5.812 11.62 8.812 18.56 8.812c5.344 0 10.75-1.781 15.19-5.406c22.53-18.44 35.44-45.4 35.44-74.05S307.1 200.4 284.6 181.9zM345.1 107.1c-10.22-8.344-25.34-6.907-33.78 3.343c-8.406 10.25-6.906 25.37 3.344 33.78c33.88 27.78 53.31 68.18 53.31 110.9s-19.44 83.09-53.31 110.9c-10.25 8.406-11.75 23.53-3.344 33.78c4.75 5.781 11.62 8.781 18.56 8.781c5.375 0 10.75-1.781 15.22-5.438C390.2 367.1 416 313.1 416 255.1S390.2 144.9 345.1 107.1zM406.4 33.15c-10.22-8.344-25.34-6.875-33.78 3.344c-8.406 10.25-6.906 25.37 3.344 33.78C431.9 116.1 464 183.8 464 255.1s-32.09 139.9-88.06 185.7c-10.25 8.406-11.75 23.53-3.344 33.78c4.75 5.781 11.62 8.781 18.56 8.781c5.375 0 10.75-1.781 15.22-5.438C473.5 423.8 512 342.6 512 255.1S473.5 88.15 406.4 33.15zM151.3 174.6C161.1 175.6 172.1 169.5 176 159.6l33.75-84.38C214 64.35 209.1 51.1 200.2 45.86l-67.47-42.17C123.2-2.289 110.9-.8945 102.9 7.08C-34.32 144.3-34.31 367.7 102.9 504.9c7.982 7.984 20.22 9.379 29.75 3.402l67.48-42.19c9.775-6.104 13.9-18.47 9.598-29.3L176 352.5c-3.945-9.963-14.14-16.11-24.73-14.97l-53.24 5.314C78.89 286.7 78.89 225.4 98.06 169.3L151.3 174.6z"
                      ></path>
                    </svg>
                  </div>
                  <div className="homepage-list-section-content">
                    <h3>24/7 Support</h3>
                    <p>Get support all day</p>
                  </div>
                </li>
                <li>
                  <div className="svg">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="rotate"
                      class="svg-inline--fa fa-rotate"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M449.9 39.96l-48.5 48.53C362.5 53.19 311.4 32 256 32C161.5 32 78.59 92.34 49.58 182.2c-5.438 16.81 3.797 34.88 20.61 40.28c16.97 5.5 34.86-3.812 40.3-20.59C130.9 138.5 189.4 96 256 96c37.96 0 73 14.18 100.2 37.8L311.1 178C295.1 194.8 306.8 223.4 330.4 224h146.9C487.7 223.7 496 215.3 496 204.9V59.04C496 34.99 466.9 22.95 449.9 39.96zM441.8 289.6c-16.94-5.438-34.88 3.812-40.3 20.59C381.1 373.5 322.6 416 256 416c-37.96 0-73-14.18-100.2-37.8L200 334C216.9 317.2 205.2 288.6 181.6 288H34.66C24.32 288.3 16 296.7 16 307.1v145.9c0 24.04 29.07 36.08 46.07 19.07l48.5-48.53C149.5 458.8 200.6 480 255.1 480c94.45 0 177.4-60.34 206.4-150.2C467.9 313 458.6 294.1 441.8 289.6z"
                      ></path>
                    </svg>
                  </div>

                  <div className="homepage-list-section-content">
                    <h3>Free Shipping</h3>
                    <p>When order over $75</p>
                  </div>
                </li>
              </ul>
            </div>
          </section>
          <section id="products" className="homepage-section-products">
            <div className="container1">
              <h2>
                <span>Our</span> products
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Aliquid, fuga quas itaque eveniet beatae optio.
              </p>

              <div className="product-card-container">
                {products !== undefined
                  ? products.map((el, id) => {
                      const img = getImage(
                        el.node.frontmatter.featuredImage.childImageSharp
                      );
                      return (
                        <ul className="product-card">
                          <li
                            className="product-card-img"
                            style={{ position: "relative" }}
                          >
                            <Link to={`/${el.node.slug}`}>
                              <GatsbyImage
                                image={img}
                                alt={el.node.frontmatter.featuredImage_alt}
                              />
                            </Link>
                          </li>
                          <li>
                            <h3>{el.node.frontmatter.featuredImage_alt}</h3>
                          </li>
                          <li>
                            <span>Per kg</span>
                            <MDXRenderer>{el.node.body}</MDXRenderer>
                          </li>
                          <li style={{ position: "relative" }}>
                            {el.cart !== "cart" ? (
                              <ButtonCart
                                img={img}
                                slug={el.node.frontmatter.featuredImage_alt}
                                price={el.node.frontmatter.price}
                                id={id}
                              ></ButtonCart>
                            ) : (
                              <Link to="/cart" className="link-cart">
                                <div className="link-cart-bg"></div>
                                <span>In a cart</span>
                              </Link>
                            )}
                          </li>
                        </ul>
                      );
                    })
                  : false}
              </div>
            </div>
          </section>
          <section className="homepage-section-owners">
            <div className="container1">
              <Carousel
                autoPlay={true}
                emulateTouch={true}
                showIndicators={true}
                showArrows={true}
                infiniteLoop={true}
              >
                {props.data.Owners.edges.map((el) => {
                  const img = getImage(
                    el.node.frontmatter.featuredImage.childImageSharp
                  );
                  return (
                    <div>
                      <ul className="corusel-item">
                        <li>
                          <GatsbyImage image={img} />
                        </li>
                        <li>
                          <h3>
                            {el.node.frontmatter.featuredImage_alt}
                            <span>Local shop owner</span>
                          </h3>
                        </li>
                        <li>
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Velit ut tortor pretium viverra
                            suspendisse potenti nullam ac tortor. Arcu risus
                            quis varius quam. Ipsum dolor sit amet consectetur
                            adipiscing elit. Nibh nisl condimentum id venenatis
                            a condimentum vitae sapien.
                          </p>
                        </li>
                        <li>
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="quote-right"
                            class="svg-inline--fa fa-quote-right"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path
                              fill="currentColor"
                              d="M96 96C42.98 96 0 138.1 0 192s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192C192 138.1 149 96 96 96zM448 192c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96c11.28 0 21.95-2.305 32-5.879V288c0 35.3-28.7 64-64 64c-17.67 0-32 14.33-32 32s14.33 32 32 32c70.58 0 128-57.42 128-128V192z"
                            ></path>
                          </svg>
                        </li>
                      </ul>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </section>
          <section className="hoamepage-section-about">
            <div className="container1">
              <div className="about-img">
                <GatsbyImage image={imgAbout} alt="Fruits" />
              </div>
              <div className="about-text">
                <h2>
                  About <span>us</span>
                </h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ultricies leo integer malesuada nunc vel. Sapien et ligula
                  ullamcorper malesuada proin libero nunc consequat interdum.
                  Erat pellentesque adipiscing commodo elit at. A pellentesque
                  sit amet porttitor eget dolor morbi non arcu. Vel orci porta
                  non pulvinar neque laoreet suspendisse interdum. Tincidunt dui
                  ut ornare lectus. Lacus laoreet non curabitur gravida. Ac
                  turpis egestas integer eget aliquet. Ultrices vitae auctor eu
                  augue ut.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Mi in nulla posuere sollicitudin aliquam ultrices sagittis.
                  Viverra nam libero justo laoreet sit amet cursus.
                </p>
                <Link to="/about">Read more</Link>
              </div>
            </div>
          </section>
          <ScrollButton />
        </div>
      </Layout>
    </>
  );
};

export default IndexPage;
export const query = graphql`
  query HomePageQuery {
    file(relativePath: { eq: "home/bg.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1980) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    allMdx(filter: { frontmatter: { title: { eq: "Product" } } }) {
      edges {
        node {
          id
          frontmatter {
            title
            featuredImage_alt
            price
            featuredImage {
              childImageSharp {
                gatsbyImageData(
                  height: 128
                  breakpoints: 100
                  layout: FULL_WIDTH
                )
                fluid(maxHeight: 128) {
                  base64
                  tracedSVG
                  srcWebp
                  srcSetWebp
                  originalImg
                  originalName
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          body
          slug
        }
      }
    }
    Owners: allMdx(filter: { frontmatter: { title: { eq: "Owner" } } }) {
      edges {
        node {
          id
          frontmatter {
            featuredImage_alt
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 100)
              }
            }
          }
        }
      }
    }
    AboutImg: file(relativePath: { eq: "home/bg.jpg" }) {
      childImageSharp {
        gatsbyImageData(sizes: "540", width: 540)
      }
    }
  }
`;
